import React, { Component } from "react";
import "./OwProgressBar.scss";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    currentPercent: number;
    showTitle?: boolean;
    title?: string;
    showTitleChunk?: boolean;
    titleChunkTotal?: number;
    titleChunkCurrent?: number;
};

type State = {};

class OwProgressBar extends Component<Props, State> {
    render() {
        return (
            <div className="OwProgressBar">
                <div className={"d-flex"}>
                    {this.props.showTitle ? <OwLabel noBottomMargin={true} title={this.props.title} className={"me-2"} /> : null}
                    {this.props.showTitleChunk ? (
                        <div>
                            {this.props.titleChunkCurrent} <OwLabel title={"of"} noBottomMargin={true} isLowercase={true} />{" "}
                            {this.props.titleChunkTotal}
                        </div>
                    ) : null}
                </div>
                <div className={"bar"}>
                    <div className={"completed-bar"} style={{ width: `${this.props.currentPercent}%` }}></div>
                </div>
            </div>
        );
    }
}

export default OwProgressBar;
